import { Schema } from "../../../core/render/logic/Markdoc";

export const ol: Schema = {
	render: "ol",
};

export const ul: Schema = {
	render: "ul",
};

export const li: Schema = {
	render: "li",
};
